const wrapperCls = "c2lwes7zpi";
const bulletCls = "c2lb120z4l3";

export { bulletCls, wrapperCls };
import "./bullets.style.linaria.module.css";
//# sourceMappingURL=bullets.style.js.map
